import '../../assets/index2.css';var G = Object.defineProperty, K = Object.defineProperties;
var Q = Object.getOwnPropertyDescriptors;
var R = Object.getOwnPropertySymbols;
var D = Object.prototype.hasOwnProperty, j = Object.prototype.propertyIsEnumerable;
var k = (s, t, d) => t in s ? G(s, t, { enumerable: !0, configurable: !0, writable: !0, value: d }) : s[t] = d, I = (s, t) => {
  for (var d in t || (t = {}))
    D.call(t, d) && k(s, d, t[d]);
  if (R)
    for (var d of R(t))
      j.call(t, d) && k(s, d, t[d]);
  return s;
}, F = (s, t) => K(s, Q(t));
var M = (s, t) => {
  var d = {};
  for (var b in s)
    D.call(s, b) && t.indexOf(b) < 0 && (d[b] = s[b]);
  if (s != null && R)
    for (var b of R(s))
      t.indexOf(b) < 0 && j.call(s, b) && (d[b] = s[b]);
  return d;
};
import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { Select as X } from "../../components/Select/index.js";
import { Avatar as h } from "../../components/Avatar/index.js";
import { SearchPopdown as J } from "../SearchPopdown/index.js";
import { QLogo as H, CogFarFAIcon as q, XMarkFarFAIcon as z, StarFarFAIcon as v, UserFarFAIcon as u, CopilotIcon as Z, CircleQuestionFarFAIcon as ee, BellFarFAIcon as ae } from "../../components/Icons/index.js";
import { Button as l } from "../../components/Button/index.js";
import { Menu as m } from "../../components/Menu/index.js";
import { Tabs as N } from "../../components/Tabs/index.js";
import { Tile as y } from "../../components/Tile/index.js";
import { useState as re } from "react";
import { SearchBar as ie } from "../../components/SearchBar/index.js";
import { B as g, a as w } from "../../index-BYV88PwO.js";
import { B as p } from "../../factory-ueRxoNOV.js";
import { F as c } from "../../Flex-BcSdq2bJ.js";
import { S as n } from "../../Stack-CTaaXTID.js";
import { T as o } from "../../Text-B7Ta53Id.js";
import { G as f } from "../../Group-CbE78j-X.js";
const le = "TopNav-module__root___5x7ly", oe = "TopNav-module__notificationBadge___H-kgP", ce = "TopNav-module__center___6w21R", se = "TopNav-module__leftSide___A5nOW", ne = "TopNav-module__rightSide___cNzlt", te = "TopNav-module__userMenu___DQIhh", de = "TopNav-module__userDropdown___UoAsa", me = "TopNav-module__officialRow___K92RX", he = "TopNav-module__officialActions___Si-ly", ge = "TopNav-module__searchContent___Ph-aX", pe = "TopNav-module__searchContentVisible___sNhUL", fe = "TopNav-module__copilotButton___bTj96", i = {
  root: le,
  notificationBadge: oe,
  center: ce,
  leftSide: se,
  rightSide: ne,
  userMenu: te,
  userDropdown: de,
  officialRow: me,
  officialActions: he,
  searchContent: ge,
  searchContentVisible: pe,
  copilotButton: fe
}, Me = (ue) => {
  var B = ue, {
    logoUrl: s,
    logoAlt: t = "Company logo",
    homeUrl: d = "/",
    organizations: b,
    selectedOrg: U = "entire-us",
    isLoading: P,
    onOrgChange: A,
    userAvatarUrl: ve,
    notificationCount: _ = 0,
    onNotificationClick: V,
    onSettingsClick: L,
    onHelpClick: x,
    onLogoutClick: W,
    onManageUsersClick: E,
    onManageOrganizationsClick: Y,
    onDownloadsClick: $,
    className: S
  } = B, O = M(B, [
    "logoUrl",
    "logoAlt",
    "homeUrl",
    "organizations",
    "selectedOrg",
    "isLoading",
    "onOrgChange",
    "userAvatarUrl",
    "notificationCount",
    "onNotificationClick",
    "onSettingsClick",
    "onHelpClick",
    "onLogoutClick",
    "onManageUsersClick",
    "onManageOrganizationsClick",
    "onDownloadsClick",
    "className"
  ]);
  const [T, C] = re(!1);
  return console.log("TopNav className:", S), /* @__PURE__ */ e(p, F(I({ className: `${i.root} ${S || ""}` }, O), { children: /* @__PURE__ */ a(c, { align: "center", justify: "space-between", h: "100%", children: [
    /* @__PURE__ */ a(c, { align: "center", gap: "md", className: i.leftSide, children: [
      /* @__PURE__ */ e("a", { href: d, "aria-label": "Go to homepage", children: /* @__PURE__ */ e(
        H,
        {
          size: 32,
          "aria-hidden": "true"
        }
      ) }),
      /* @__PURE__ */ e(
        X,
        {
          label: " ",
          data: [
            { label: "Entire US", value: "entire-us" },
            ...b
          ],
          value: U,
          onChange: (r) => r && (A == null ? void 0 : A(r)),
          placeholder: "Select organization",
          disabled: P,
          "aria-label": "Select your organization"
        }
      )
    ] }),
    /* @__PURE__ */ e(c, { align: "center", gap: "md", className: i.center, children: /* @__PURE__ */ e(
      J,
      {
        opened: T,
        onOpenChange: C,
        target: /* @__PURE__ */ e(
          ie,
          {
            placeholder: "Search anything",
            onChange: (r) => console.log("Search:", r),
            onClick: () => C(!0)
          }
        ),
        children: /* @__PURE__ */ e(
          c,
          {
            align: "center",
            gap: "md",
            direction: "column",
            w: "100%",
            className: `${i.searchContent} ${T ? i.searchContentVisible : ""}`,
            children: /* @__PURE__ */ a(n, { gap: "md", px: "0", ml: "auto", mr: "auto", pt: "2rem", align: "center", w: "100%", children: [
              /* @__PURE__ */ a(c, { w: "100%", maw: "50rem", ml: "auto", mr: "auto", align: "center", children: [
                /* @__PURE__ */ e(o, { fw: 500, size: "xl", c: "gray.9", children: "Search" }),
                /* @__PURE__ */ e(
                  l,
                  {
                    ml: "auto",
                    mr: "1rem",
                    variant: "tertiary",
                    size: "sm",
                    onClick: () => C(!1),
                    "aria-label": "Settings",
                    children: /* @__PURE__ */ e(q, {})
                  }
                ),
                /* @__PURE__ */ e(
                  l,
                  {
                    variant: "secondary",
                    size: "lg",
                    onClick: () => C(!1),
                    "aria-label": "Close search",
                    children: /* @__PURE__ */ e(z, {})
                  }
                )
              ] }),
              /* @__PURE__ */ a(N, { defaultValue: "recent", w: "100%", children: [
                /* @__PURE__ */ a(N.List, { maw: "50rem", ml: "auto", mr: "auto", children: [
                  /* @__PURE__ */ e(N.Tab, { value: "recent", children: "Recent" }),
                  /* @__PURE__ */ e(N.Tab, { value: "favorites", children: "Favorites" }),
                  /* @__PURE__ */ e(N.Tab, { value: "datasets", children: "Datasets" })
                ] }),
                /* @__PURE__ */ e(N.Panel, { value: "recent", w: "100%", maw: "50rem", ml: "auto", mr: "auto", children: /* @__PURE__ */ e(n, { gap: "md", pt: "1rem", w: "100%", maw: "100%", children: /* @__PURE__ */ a(n, { gap: "xxs", children: [
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, w: "100%", children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/s000033.jpg",
                          alt: "Bernie Sanders",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.democrat[3],
                              color: r.colors.democrat[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Democrat",
                          children: "D"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Bernie Sanders" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "Senator, Vermont" })
                    ] }),
                    /* @__PURE__ */ a(f, { gap: "xs", className: i.officialActions, children: [
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Add to favorites", children: /* @__PURE__ */ e(v, {}) }),
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove", children: /* @__PURE__ */ e(z, {}) })
                    ] })
                  ] }),
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/y000064.jpg",
                          alt: "Todd Young",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.republican[3],
                              color: r.colors.republican[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Republican",
                          children: "R"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Todd Young" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "Senator, Indiana" })
                    ] }),
                    /* @__PURE__ */ a(f, { gap: "xs", className: i.officialActions, children: [
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Add to favorites", children: /* @__PURE__ */ e(v, {}) }),
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove", children: /* @__PURE__ */ e(z, {}) })
                    ] })
                  ] }),
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/p000197.jpg",
                          alt: "Nancy Pelosi",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.democrat[3],
                              color: r.colors.democrat[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Democrat",
                          children: "D"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Nancy Pelosi" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "Representative, California" })
                    ] }),
                    /* @__PURE__ */ a(f, { gap: "xs", className: i.officialActions, children: [
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Add to favorites", children: /* @__PURE__ */ e(v, {}) }),
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove", children: /* @__PURE__ */ e(z, {}) })
                    ] })
                  ] }),
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/s000148.jpg",
                          alt: "Chuck Schumer",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.democrat[3],
                              color: r.colors.democrat[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Democrat",
                          children: "D"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Chuck Schumer" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "Senate Majority Leader" })
                    ] }),
                    /* @__PURE__ */ a(f, { gap: "xs", className: i.officialActions, children: [
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Add to favorites", children: /* @__PURE__ */ e(v, {}) }),
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove", children: /* @__PURE__ */ e(z, {}) })
                    ] })
                  ] }),
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/m000314.jpg",
                          alt: "Kevin McCarthy",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.republican[3],
                              color: r.colors.republican[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Republican",
                          children: "R"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Kevin McCarthy" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "House Minority Leader" })
                    ] }),
                    /* @__PURE__ */ a(f, { gap: "xs", className: i.officialActions, children: [
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Add to favorites", children: /* @__PURE__ */ e(v, {}) }),
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove", children: /* @__PURE__ */ e(z, {}) })
                    ] })
                  ] }),
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/w000187.jpg",
                          alt: "Elizabeth Warren",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.democrat[3],
                              color: r.colors.democrat[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Democrat",
                          children: "D"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Elizabeth Warren" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "Senator, Massachusetts" })
                    ] }),
                    /* @__PURE__ */ a(f, { gap: "xs", className: i.officialActions, children: [
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Add to favorites", children: /* @__PURE__ */ e(v, {}) }),
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove", children: /* @__PURE__ */ e(z, {}) })
                    ] })
                  ] }),
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/c001056.jpg",
                          alt: "Ted Cruz",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.republican[3],
                              color: r.colors.republican[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Republican",
                          children: "R"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Ted Cruz" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "Senator, Texas" })
                    ] }),
                    /* @__PURE__ */ a(f, { gap: "xs", className: i.officialActions, children: [
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Add to favorites", children: /* @__PURE__ */ e(v, {}) }),
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove", children: /* @__PURE__ */ e(z, {}) })
                    ] })
                  ] }),
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/o000172.jpg",
                          alt: "Alexandria Ocasio-Cortez",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.democrat[3],
                              color: r.colors.democrat[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Democrat",
                          children: "D"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Alexandria Ocasio-Cortez" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "Representative, New York" })
                    ] }),
                    /* @__PURE__ */ a(f, { gap: "xs", className: i.officialActions, children: [
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Add to favorites", children: /* @__PURE__ */ e(v, {}) }),
                      /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove", children: /* @__PURE__ */ e(z, {}) })
                    ] })
                  ] })
                ] }) }) }),
                /* @__PURE__ */ e(N.Panel, { value: "favorites", w: "100%", maw: "50rem", ml: "auto", mr: "auto", children: /* @__PURE__ */ e(n, { gap: "md", pt: "1rem", w: "100%", maw: "100%", children: /* @__PURE__ */ a(n, { gap: "xxs", children: [
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/s000033.jpg",
                          alt: "Bernie Sanders",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.democrat[3],
                              color: r.colors.democrat[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Democrat",
                          children: "D"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Bernie Sanders" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "Senator, Vermont" })
                    ] }),
                    /* @__PURE__ */ e(f, { gap: "xs", className: i.officialActions, children: /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove from favorites", children: /* @__PURE__ */ e(v, { filled: !0 }) }) })
                  ] }),
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/o000172.jpg",
                          alt: "Alexandria Ocasio-Cortez",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.democrat[3],
                              color: r.colors.democrat[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Democrat",
                          children: "D"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Alexandria Ocasio-Cortez" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "Representative, New York" })
                    ] }),
                    /* @__PURE__ */ e(f, { gap: "xs", className: i.officialActions, children: /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove from favorites", children: /* @__PURE__ */ e(v, { filled: !0 }) }) })
                  ] }),
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/y000064.jpg",
                          alt: "Todd Young",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.republican[3],
                              color: r.colors.republican[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Republican",
                          children: "R"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Todd Young" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "Senator, Indiana" })
                    ] }),
                    /* @__PURE__ */ e(f, { gap: "xs", className: i.officialActions, children: /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove from favorites", children: /* @__PURE__ */ e(v, { filled: !0 }) }) })
                  ] }),
                  /* @__PURE__ */ a(c, { gap: "md", align: "center", className: i.officialRow, children: [
                    /* @__PURE__ */ a(p, { pos: "relative", children: [
                      /* @__PURE__ */ e(
                        h,
                        {
                          src: "https://www.congress.gov/img/member/w000187.jpg",
                          alt: "Elizabeth Warren",
                          size: "lg"
                        }
                      ),
                      /* @__PURE__ */ e(
                        g,
                        {
                          variant: "dot",
                          styles: (r) => ({
                            root: {
                              backgroundColor: r.colors.democrat[3],
                              color: r.colors.democrat[8]
                            }
                          }),
                          className: w.partyBadge,
                          "aria-label": "Democrat",
                          children: "D"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a(n, { gap: 0, children: [
                      /* @__PURE__ */ e(o, { fw: 500, c: "gray.9", size: "md", children: "Elizabeth Warren" }),
                      /* @__PURE__ */ e(o, { c: "gray.7", size: "sm", children: "Senator, Massachusetts" })
                    ] }),
                    /* @__PURE__ */ e(f, { gap: "xs", className: i.officialActions, children: /* @__PURE__ */ e(l, { variant: "tertiary", size: "sm", "aria-label": "Remove from favorites", children: /* @__PURE__ */ e(v, { filled: !0 }) }) })
                  ] }),
                  !1
                ] }) }) }),
                /* @__PURE__ */ e(N.Panel, { value: "datasets", w: "100%", maw: "50rem", ml: "auto", mr: "auto", styles: { panel: { overflow: "visible" } }, children: /* @__PURE__ */ a(n, { gap: "md", pt: "1rem", w: "100%", maw: "100%", align: "center", styles: { root: { flexDirection: "row", flexWrap: "wrap" } }, children: [
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Officials"
                    }
                  ),
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Bills"
                    }
                  ),
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Documents"
                    }
                  ),
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Staffers"
                    }
                  ),
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Contacts"
                    }
                  ),
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Notes"
                    }
                  ),
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Grassroots"
                    }
                  ),
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Official Events"
                    }
                  ),
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Votes"
                    }
                  ),
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Amendments"
                    }
                  ),
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Regulations"
                    }
                  ),
                  /* @__PURE__ */ e(
                    y,
                    {
                      variant: "primary",
                      size: "md",
                      icon: /* @__PURE__ */ e(u, {}),
                      flex: 1,
                      children: "Committees"
                    }
                  )
                ] }) })
              ] })
            ] })
          }
        )
      }
    ) }),
    /* @__PURE__ */ a(c, { align: "center", gap: "sm", className: i.rightSide, children: [
      /* @__PURE__ */ a(c, { pos: "relative", gap: "xxs", children: [
        /* @__PURE__ */ e(f, { gap: "xs", className: i.copilotButton, children: /* @__PURE__ */ e(
          l,
          {
            variant: "tertiary",
            size: "md",
            "aria-label": "Copilot",
            children: /* @__PURE__ */ e(Z, {})
          }
        ) }),
        /* @__PURE__ */ a(m, { children: [
          /* @__PURE__ */ e(m.Target, { children: /* @__PURE__ */ e(
            l,
            {
              variant: "tertiary",
              size: "md",
              "aria-label": "Help",
              children: /* @__PURE__ */ e(ee, {})
            }
          ) }),
          /* @__PURE__ */ a(m.Dropdown, { children: [
            /* @__PURE__ */ e(m.Item, { onClick: x, children: "Help center" }),
            /* @__PURE__ */ e(m.Item, { onClick: x, children: "Contact us" }),
            /* @__PURE__ */ e(m.Item, { onClick: x, children: "Launch chat" }),
            /* @__PURE__ */ e(m.Item, { onClick: x, children: "What's new" })
          ] })
        ] }),
        /* @__PURE__ */ e(
          l,
          {
            variant: "tertiary",
            size: "md",
            onClick: V,
            "aria-label": `Notifications ${_ > 0 ? `(${_} unread)` : ""}`,
            children: /* @__PURE__ */ e(ae, {})
          }
        ),
        _ > 0 && /* @__PURE__ */ e(
          g,
          {
            className: i.notificationBadge,
            size: "sm",
            variant: "filled",
            children: _
          }
        )
      ] }),
      /* @__PURE__ */ a(m, { children: [
        /* @__PURE__ */ e(m.Target, { children: /* @__PURE__ */ e(
          h,
          {
            src: "https://i.pravatar.cc/150?u=12",
            children: "User",
            size: "sm",
            alt: "User avatar"
          }
        ) }),
        /* @__PURE__ */ a(m.Dropdown, { className: i.userDropdown, children: [
          /* @__PURE__ */ a(c, { gap: "0", direction: "column", className: i.userMenu, children: [
            /* @__PURE__ */ e("span", { children: "Joshua Johnson" }),
            /* @__PURE__ */ e("span", { children: "joshua.johnson@company.org" })
          ] }),
          /* @__PURE__ */ e(m.Item, { onClick: L, children: "Settings" }),
          /* @__PURE__ */ e(m.Item, { onClick: E, children: "Manage users" }),
          /* @__PURE__ */ e(m.Item, { onClick: Y, children: "Manage organizations" }),
          /* @__PURE__ */ e(m.Item, { onClick: $, children: "Download & Uploads" }),
          /* @__PURE__ */ e(m.Divider, {}),
          /* @__PURE__ */ e(m.Item, { onClick: W, "data-danger": !0, children: "Logout" })
        ] })
      ] })
    ] })
  ] }) }));
};
export {
  Me as TopNav
};
